// Shop-theme preset catalog + value allowlists. The enum lists are hardcoded
// (and pinned to common-contracts/shop_presets.json in shopPresets.test.ts) so
// they drive TS union types; the preset token VALUES are imported straight from
// the JSON because the gallery renders them and they cannot drift from
// themselves.
import presetsJson from '../../../common-contracts/shop_presets.json';

export const THEME_FONTS = ['inter', 'roboto', 'poppins', 'lora', 'montserrat', 'roboto-slab'] as const;
export type ThemeFont = (typeof THEME_FONTS)[number];

export const THEME_RADII = ['sharp', 'rounded', 'soft'] as const;
export type ThemeRadius = (typeof THEME_RADII)[number];

export const THEME_SURFACES = ['light'] as const;
export type ThemeSurface = (typeof THEME_SURFACES)[number];

export interface ThemeTokens {
  preset?: string;
  brand_primary: string;
  brand_accent: string;
  surface: ThemeSurface;
  font: ThemeFont;
  radius: ThemeRadius;
}

export type PresetTokens = Omit<ThemeTokens, 'preset'>;

export const SHOP_PRESETS = presetsJson.presets as Record<string, PresetTokens>;
export const PRESET_ORDER: string[] = Object.keys(presetsJson.presets);

// The faces themselves are self-hosted via src/theme/fonts.ts (fontsource).
export const FONT_FAMILIES: Record<ThemeFont, { stack: string }> = {
  inter: { stack: "'Inter', sans-serif" },
  roboto: { stack: "'Roboto', sans-serif" },
  poppins: { stack: "'Poppins', sans-serif" },
  lora: { stack: "'Lora', serif" },
  montserrat: { stack: "'Montserrat', sans-serif" },
  'roboto-slab': { stack: "'Roboto Slab', serif" },
};

export const DEFAULT_THEME: ThemeTokens = { preset: 'classic', ...SHOP_PRESETS.classic };
